<template>
  <div class="beci-brussels scrollable">

    <div class="beci-brussels-container">
      <div class="brussels__logo" id="home">
        <img
          src="/images/static-home-page/brussels/top-image-beci-2.png"
          alt="BECI Logo"
        />
        <div class="brussels__logo-overlay">
          <div class="brussels__logo-content">
            <h2 class="brussels__logo-text">
              500+ ways to<br>
              grow your business<br>
              in Brussels
            </h2>
          </div>
        </div>
      </div>

      <div class="brussels-content-container">
        <div id="about" style="margin-bottom: 2.5rem; margin-top: 2.5rem;">
          <h1 style="font-size: 2.25rem;">Brussels: capital of entrepreneurship</h1>
          <div style="margin-top: 1rem;">
            <p style=" font-weight: 100;">
              Brussels is more than a capital city; it's a capital of entrepreneurship, buzzing with innovators, SMEs,
              and
              industry leaders.
              Positioned at the heart of Europe, it combines international reach with a uniquely accessible and
              collaborative ecosystem. This platform is the definitive map to navigate it all.
              Explore the connections, discover the opportunities, and find your place in Brussels vibrant ecosystem.
            </p>
          </div>
        </div>

        <div v-if="actors && actors.data && actors.data.length >= 1" style="margin-bottom: 2.5rem;">
          <h2 class="h2" style="font-size: 1.75rem;">Latest actors</h2>

          <div class="row">
            <div
              class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 home-simplified__space-vertical"
              v-for="(actor, index) in actors.data.slice(0, 3)"
              :key="'actor' + index"
            >
              <SimpleCard
                :imgUrl="actor.featured_image_url || actor.website_screenshot || getDefaultFallbackImageUrl()"
                :force-aspect-ratio="true"
                :title="actor.name"
                :content="localizedDisplayProperty(actor, 'short_description') || localizedDisplayProperty(actor, 'activities_description')"
                @click="handleClickActorCard(actor)"
              />
            </div>
          </div>

          <div style="flex: 1; display: flex; justify-content: center;">
            <DsButton
              style="background-color: #38B6FF; color: white; border-radius: 25px; border: none; padding: 12px 24px;"
              label="More >"
              color=""
              @click="$router.push('/actors-simplified')"
            />
          </div>
        </div>

        <div id="map">
          <h2 class="h2" style="font-size: 1.75rem;">Map</h2>

          <div style="height: 500px; position: relative; margin-top: 1.5rem;">
            <MapView
              ref="mapPane"
              :data="mapData.data"
              :getMapData="getMapData"
              :getData="getMapData"
              :noSearchWhileMoving="true"
              :disableMouseWheelZoom="true"
            />
          </div>
        </div>
      </div>

      <!--<div class="background-color-filled-section">
        <div class="brussels-content-container" style="">
          <h2 id="how-it-works" class="h2" style="font-size: 1.75rem;">How it works</h2>

          <div style="margin-top: 2rem;">
            <h3 style="font-size: 1.5rem; margin-bottom: 1rem;">Your ecosystem map</h3>
            <p style="font-weight: 100; margin-bottom: 1rem;">
              Every company follows its own path. Sometimes you're at the very beginning with only an
              idea. Sometimes you're already growing and need to solve tough challenges. And sometimes
              you're leading a large business and want to explore new partnerships or markets.
            </p>
            <p style="font-weight: 100; margin-bottom: 2rem;">
              This platform helps you see where to go next and who in Brussels can help you move faster.
            </p>

            <ul style="margin-left: 1.5rem; margin-bottom: 2rem;">
              <li style="margin-bottom: 1.5rem;">
                <strong>Idea: you're exploring and testing</strong><br>
                <span style="font-weight: 100;">BUTTON Find: coworking spaces, creative jams, prototyping labs, mentorship circles.</span>
              </li>
              <li style="margin-bottom: 1.5rem;">
                <strong>Early Revenue: you're selling but still fragile.</strong><br>
                <span style="font-weight: 100;">BUTTON Find: incubators, accelerators, go-to-market programs, microfunding, legal/accounting help.</span>
              </li>
              <li style="margin-bottom: 1.5rem;">
                <strong>Growth: you're building systems and teams.</strong><br>
                <span style="font-weight: 100;">BUTTON Find: HR and hiring support, export services, growth capital, sales enablement, sector clusters.</span>
              </li>
              <li style="margin-bottom: 1.5rem;">
                <strong>Expansion: you're looking outward.</strong><br>
                <span style="font-weight: 100;">BUTTON Find: trade missions, international networks, advanced financing, corporate partnerships.</span>
              </li>
            </ul>

            <p style="font-weight: 100; margin-bottom: 2rem;">
              Whether you're starting up, holding an SME together, or steering a big company, this platform
              helps you see where to go next and who in Brussels can help you move faster.
            </p>

            <h3 style="font-size: 1.5rem; margin-bottom: 1rem;">What you can find today</h3>
            <p style="font-weight: 100; margin-bottom: 1.5rem;">
              The platform already includes categories such as:
            </p>

            <ul style="margin-left: 1.5rem; margin-bottom: 1.5rem; display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem;">
              <li style="margin-bottom: 0.5rem;">Incubators & accelerators</li>
              <li style="margin-bottom: 0.5rem;">Public support programs</li>
              <li style="margin-bottom: 0.5rem;">Coworking spaces</li>
              <li style="margin-bottom: 0.5rem;">Community events</li>
              <li style="margin-bottom: 0.5rem;">Prototyping labs</li>
              <li style="margin-bottom: 0.5rem;"></li>
              <li style="margin-bottom: 0.5rem;">Investor networks</li>
              <li style="margin-bottom: 0.5rem;"></li>
              <li style="margin-bottom: 0.5rem;">Training providers</li>
              <li style="margin-bottom: 0.5rem;"></li>
            </ul>

            <p style="font-weight: 100;">
              Coverage will expand continuously. If you see something is missing or have a suggestion, let
              us know. Your input shapes what comes next.
            </p>
          </div>
        </div>
      </div>-->

      <div class="brussels-content-container" style="margin-bottom: 2.5rem; margin-top: 2.5rem;">
        <!--<h2 id="about-section" class="h2" style="font-size: 1.75rem;">About</h2>

        <div style="margin-top: 2rem;">
          <h3 style="font-size: 1.5rem; margin-bottom: 1rem;">The challenge: a vibrant but scattered ecosystem</h3>
          <p style="font-weight: 100; margin-bottom: 2rem;">
            The Brussels business ecosystem is vibrant and full of opportunities, but finding the right
            information isn't always clear. Whether you're an entrepreneur looking for funding, an SME
            seeking growth services, or a corporation scouting for innovative partners, that key
            information is often scattered.
          </p>

          <h3 style="font-size: 1.5rem; margin-bottom: 1rem;">Our mission: bringing it all together</h3>
          <p style="font-weight: 100; margin-bottom: 1rem;">
            This platform was created to solve that challenge. Built by <strong>Beci</strong> in collaboration with
            <strong><a href="https://datascouts.eu">DataScouts</a></strong>, our mission is to bring the entire ecosystem together in one place.
          </p>
          <p style="font-weight: 100; margin-bottom: 2rem;">
            We provide a dynamic map that shows you where to go and who to meet at each stage of
            your journey. From validating an idea to forging a corporate partnership, you'll find the right
            people, spaces, and programs to help you achieve your goals.
          </p>

          <h3 style="font-size: 1.5rem; margin-bottom: 1rem;">Who is it for?</h3>
          <p style="font-weight: 100; margin-bottom: 1.5rem;">
            This platform is designed for every actor in the Brussels business ecosystem.
          </p>

          <div style="margin-bottom: 2rem;">
            <h4 style="font-size: 1.25rem; margin-bottom: 1rem;"><strong>For those building and growing a
              venture:</strong></h4>
            <ul style="margin-left: 1.5rem; margin-bottom: 1.5rem;">
              <li style="margin-bottom: 0.5rem;"><strong>Innovators</strong> testing a new business idea</li>
              <li style="margin-bottom: 0.5rem;"><strong>Young companies</strong> building their market presence and
                revenue
              </li>
              <li style="margin-bottom: 0.5rem;"><strong>Established SMEs</strong> structuring for growth and efficiency
              </li>
              <li style="margin-bottom: 0.5rem;"><strong>Leading businesses</strong> expanding into new markets or
                launching new projects
              </li>
            </ul>

            <h4 style="font-size: 1.25rem; margin-bottom: 1rem;"><strong>For those looking to connect and
              innovate:</strong></h4>
            <ul style="margin-left: 1.5rem; margin-bottom: 2rem;">
              <li style="margin-bottom: 0.5rem;"><strong>Corporate teams</strong> scouting for new technologies and
                promising startups
              </li>
              <li style="margin-bottom: 0.5rem;"><strong>Investors</strong> identifying opportunities and tracking
                market trends
              </li>
              <li style="margin-bottom: 0.5rem;"><strong>Support organizations</strong> aiming to increase their
                visibility and connect with relevant businesses
              </li>
            </ul>
          </div>

          <h3 style="font-size: 1.5rem; margin-bottom: 1rem;">Backed by BECI</h3>
          <p style="font-weight: 100;">
            This initiative reflects <strong>BECI's mission</strong>: to represent, connect, and serve the Brussels
            business
            community. With 35,000 companies across the region, BECI works to make Brussels a strong,
            sustainable, and international hub.
          </p>
        </div>
      </div>-->

        <!--<div class="background-color-filled-section">
          <div class="brussels-content-container" style="margin-bottom: 2.5rem;">
            <h2 id="faq" class="h2" style="font-size: 1.75rem;">FAQ</h2>

            <div style="margin-top: 2rem;">
              <div style="margin-bottom: 2rem;">
                <h3 style="font-size: 1.25rem; margin-bottom: 0.5rem;"><strong>What is this?</strong></h3>
                <p style="font-weight: 100;">A free online map of Brussels places and programs for entrepreneurs.</p>
              </div>

              <div style="margin-bottom: 2rem;">
                <h3 style="font-size: 1.25rem; margin-bottom: 0.5rem;"><strong>Is it free?</strong></h3>
                <p style="font-weight: 100;">Yes. Access is open for everyone.</p>
              </div>

              <div style="margin-bottom: 2rem;">
                <h3 style="font-size: 1.25rem; margin-bottom: 0.5rem;"><strong>Who curates it?</strong></h3>
                <p style="font-weight: 100;">BECI with support from DataScouts, plus input from partners.</p>
              </div>

              <div style="margin-bottom: 2rem;">
                <h3 style="font-size: 1.25rem; margin-bottom: 0.5rem;"><strong>How do I get listed?</strong></h3>
                <p style="font-weight: 100;">Use the "Suggest a place" form — we review all entries.</p>
              </div>

              <div style="margin-bottom: 2rem;">
                <h3 style="font-size: 1.25rem; margin-bottom: 0.5rem;"><strong>How often is it updated?</strong></h3>
                <p style="font-weight: 100;">Continuously. New places are added as feedback comes in.</p>
              </div>

              <div style="margin-bottom: 2rem;">
                <h3 style="font-size: 1.25rem; margin-bottom: 0.5rem;"><strong>How do the stages work?</strong></h3>
                <p style="font-weight: 100;">They reflect typical growth paths: Idea → Early Revenue → Growth →
                  Expansion.</p>
              </div>
            </div>
          </div>-->
      </div>

      <div class="beci-brussels-supporters__container brussels-content-container">
        <div style="max-width: 350px; margin-left: -70px;">
          <img src="/images/static-home-page/brussels/beci-brussels-logo-text.png">
        </div>

        <div class="powered-by-section">
          <img src="/images/static-home-page/brussels/beci-brussels-logo.png" style="max-width: 150px;">
          <div>Powered by <a href="http://beci.be" style="color: #001489; text-decoration: none; font-weight: bold;">Beci</a></div>
        </div>

        <div class="navigation-links">
          <a href="#home">Home</a>
          <a href="#map">Map</a>
          <a href="#contact">Contact</a>
        </div>
      </div>

    </div>

    <footer class="greentex-footer" v-if="!ui.isMobile">
      <div style="margin-left: 1rem; display: flex; align-items: center;">
        In collaboration with&nbsp;<a style="color: white;" href="https://datascouts.eu">DataScouts</a>
      </div>

      <div class="beci-footer-policy-list">
        <a :href="termsOfUseUrl">Terms of use</a>
        <span>-</span>
        <a :href="privacyPolicyUrl">Privacy Policy</a>
        <span>-</span>
        <a :href="cookiePolicyUrl">Cookie Policy</a>
      </div>
    </footer>

    <div class="beci-mobile-footer" v-else>
      <p style="font-size: 14px; margin-top: 1rem;">In collaboration with&nbsp;<a style="color: white;" href="https://datascouts.eu">DataScouts</a></p>
      <a style="color: white;" :href="termsOfUseUrl">Terms of use</a>
      <a style="color: white;" :href="privacyPolicyUrl">Privacy Policy</a>
      <a style="color: white;" :href="cookiePolicyUrl">Cookie Policy</a>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import SimpleCard from '@/components/SimpleCard/SimpleCard.vue'
  import { trackHeapEvent } from '@/util/analytics'
  import { getDefaultFallbackImageUrl } from '@/util/helpers'
  import TranslationsMixin from '@/util/TranslationsMixin'
  import { ACTION_TYPES as ACTORS_ACTION_TYPES } from '@/store/modules/actors'
  import MapView from '@/components/MapView/MapView.vue'
  import { DEFAULT_URLS } from '@/constants/default-urls'
  import UiMixin from '@/util/UiMixin'

  export default defineComponent({
    name: "StaticHomeBrussels",
    data() {
      return {}
    },
    methods: {
      getDefaultFallbackImageUrl,
      trackHeapEvent,
      handleClickActorCard(actor) {
        trackHeapEvent('basicHomepageSimplified.clickActorCard')

        this.$router.push(`/actors/${actor.id}`)
      },
      fetchFilteredActors() {
        const listFilters = { ...this.$store.getters.listFilterObject }
        this.$store.dispatch(ACTORS_ACTION_TYPES.FETCH_ACTORS_LIST, Object.assign({}, this.actorFilters, listFilters))

        if (this.$store.getters.isProductEnabled) {
          this.$store.dispatch(ACTORS_ACTION_TYPES.FETCH_PRODUCTS_LIST, Object.assign({}, this.productFilters, listFilters))
        }
      },
      getMapData() {
        let filters
        if (this.$store.state.config && this.$store.state.config.viewActorTypes && this.$store.state.config.viewActorTypes.length) {
          filters = Object.assign({}, this.$store.getters.mapFilterObject, { actor_type: this.$store.state.config.viewActorTypes })
        } else {
          filters = Object.assign({}, this.$store.getters.mapFilterObject)
        }

        if (filters.tl) {
          this.$store.dispatch(ACTORS_ACTION_TYPES.FETCH_ACTORS_MAP, filters)
        }
      },
      renderMap() {
        this.$refs.mapPane && this.$refs.mapPane[0] && this.$refs.mapPane[0].invalidateSize()
      },
    },
    computed: {
      mapData() {
        return this.$store.state.actors.mapData
      },
      actors() {
        return this.$store.state.actors.listData
      },
      termsOfUseUrl() {
        return this.$store.state.config.termsOfUseUrl || DEFAULT_URLS.TERMS_OF_USE
      },
      privacyPolicyUrl() {
        return this.$store.state.config.privacyPolicyUrl || DEFAULT_URLS.PRIVACY_POLICY
      },
      cookiePolicyUrl() {
        return this.$store.state.config.cookiePolicyUrl || DEFAULT_URLS.COOKIE_POLICY
      },
    },
    mounted() {
      this.fetchFilteredActors()
    },
    watch: {
      'mapData': {
        handler(newValue, oldValue) {
          if (newValue.length !== oldValue.length) {
            setTimeout(this.renderMap, 200)
          }
        },
      }
    },
    mixins: [TranslationsMixin, UiMixin],
    components: {
      MapView,
      SimpleCard
    }
  })
</script>

<style scoped lang="scss">

  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap');

  $primaryBrusselsColor: #001489;
  $primaryLightBursselsColor: #38B6FF;
  $darkGreentexColor: #003f4d;
  $pinkGreentexColor: #f7d1d7;

  .brussels-content-container {
    max-width: 900px;
    margin: 0 auto;
    color: $primaryBrusselsColor;
    padding: 0 1rem;
  }

  .beci-mobile-footer {
    min-height: 160px;
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    background-color: $primaryBrusselsColor;
    color: white;
    bottom: 0;
    position: relative;
    margin-top: 1rem;
  }

  .beci-brussels-supporters__container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 2rem;
    border-bottom: 1px solid #e0e0e0;

    .powered-by-section {
      font-size: 14px;
      color: #666;
    }

    .navigation-links {
      display: flex;
      flex-direction: column;
      gap: 0.2rem;

      a {
        color: #001489;
        text-decoration: none;
        font-size: 14px;
        font-weight: 500;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .background-color-filled-section {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    background-color: rgba(56, 182, 255, 0.1);
    padding: 2rem 0;
  }

  .greentex_regional_locations-list {
    padding-bottom: 100px;

    li {
      p {
        .svg-icon {
          :deep(path) {
            fill: white;
          }
        }
      }
    }
  }

  .beci-brussels-container {
    position: relative;

    .circular-economy-tools {
      height: auto;
      min-height: auto !important;
    }

    .brussels__logo__blanc {
      position: absolute;
      right: 0px;
      transform: translateX(49%);
      bottom: 0;
      z-index: 1;
    }
  }

  .beci-brussels-container.primary {
    min-height: 100vh;
    position: relative;
  }

  .beci-brussels-container.pink {
    min-height: 100vh;
    position: relative;
    background-color: $pinkGreentexColor;
  }

  .beci-brussels {
    font-family: 'Inter', sans-serif;
    width: 100vw;
    position: relative;
    z-index: 1;

    h1 {
      font-size: 50px;
    }

    p {
      font-size: 18px;
    }

    h1, h2, h3, h4 {
      color: $primaryBrusselsColor;
      margin: 0 auto;
    }

    h4 {
      font-size: 21px;

      &.greentex_discover-text-27 {
        font-size: 27px !important;
        margin-top: 50px;
        margin-bottom: 50px;
      }
    }

    .greentex__button-container {
      margin: 30px auto 0px auto;
      padding-bottom: 20px;
      position: relative;
      z-index: 25;

      display: flex;
      justify-content: space-evenly;
      width: 50%;

      .greentex__button {
        text-transform: uppercase;
        font-weight: bolder;
        text-decoration: none;
        background-color: $darkGreentexColor;
        padding: 10px 10px 10px 10px;
        color: white;
        font-size: 22px;
        min-width: 350px;
        margin-bottom: 15px;
        text-align: center;

        &:hover {
          color: $darkGreentexColor;
          background-color: white;
        }
      }
    }

    @media only screen and (max-width: 600px) {
      .greentex__button-container {

      }
    }

    .beci-brussels-container {
      width: 100vw;
      min-height: calc(100vh - 75px - 70px);
      height: auto;

      .brussels__logo {
        width: 100%;
        height: 650px;
        margin: 0 auto;
        margin-top: -30px;
        position: relative;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
          display: block;
        }

        .brussels__logo-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0, 0, 0, 0.3);
        }

        .brussels__logo-content {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 2rem;
        }

        .brussels__header-logo {
          width: 150px;
          height: auto;
        }

        .brussels__logo-text {
          color: white;
          font-weight: 500;
          font-size: 3.5rem;
          text-align: center;
          margin: 0;
          padding: 0 2rem;
          max-width: 600px;
          line-height: 1.2;
        }
      }

      .greentex__discover {
        text-align: center;
        margin: 0 auto;
        position: relative;

        .greentax-discover-container {
          z-index: 120;
          position: relative;
        }

        .greentex__logo__watermark {
          position: absolute;
          height: 83vh;
          right: -1px;
          opacity: 0.3;
          z-index: 1;

          :deep(path) {
            fill: white;
          }

        }

        /*.greentex-watermark-container {
          z-index: 1;

          :deep(path) {
            fill: white;
          }


        }*/


        h1 {
          margin-top: -40px;
          z-index: 2;
          position: relative;
        }

        h4 {
          margin-top: -40px;
          z-index: 2;
          position: relative;
        }

        .greentex_discover-text {
          margin-top: 30px;
          align-self: center;
        }
      }
    }

    .greentex__objectives {
      text-align: center;
      margin: 0 auto;
      position: relative;

      h1 {
        padding-top: 30px;
        padding-bottom: 30px;
      }

      .greentex__objectives__data {
        margin-top: 40px;
        width: 90%;

        margin: 0 auto;

        .greentex_objective {
          margin: 0 auto;
          margin-bottom: 30px;

          .greentex_objective__image-container {
            width: 160px;
            background-color: white;
            border-radius: 80px;
            margin: 0 auto;
            position: relative;
            margin-bottom: -80px;

            .objective__image {
              padding: 40px;
            }
          }

          .objective__text {
            font-size: 22px;
            background-color: white;
            padding: 75px 20px 0px 20px;
            height: 500px;
            max-width: 100%;
            width: 320px;
          }
        }
      }
    }

    .greentex_regional_dimension {
      h1, h4 {
        text-align: center;
      }

      h1 {
        padding-top: 50px;
      }

      h4 {
        padding-top: 40px;
        font-weight: 400;

      }

      .greentex_regional_dimension-map {
        margin: 0 auto;
        justify-content: center;
        display: flex;
        flex-direction: row;
        width: 100%;

        .greentex_regional_locations-list {
          justify-content: flex-end;
          display: flex;
          flex-direction: column;

          li {
            text-align: left;

            p {
              max-width: 100%;
              color: $darkGreentexColor;

              :deep(.path) {
                color: white;
              }
            }
          }
        }

        .greentex_regional_dimension-image-container {
          width: 30%;
          position: relative;

          .greentex_regional_dimension-image {
            width: 100%;
            z-index: 1;
          }

          .greentex_region_dimension-image-overlay {
            z-index: 5;
            background: linear-gradient(to bottom, $primaryBrusselsColor 0%, $primaryBrusselsColor 10%, transparent);
            position: absolute;
            width: 100%;
            height: 10%;
          }
        }
      }
    }


    .greentex__investment-dimension {
      width: 100%;
      position: relative;
      text-align: center;

      h1 {
        padding: 50px 0px 30px 0px;
        max-width: 100%;
      }

      h4 {
        font-weight: 400;
      }

      .greentex__investment-dimension-image {
        text-align: center;
        margin: 0 auto;
        width: 100%;

        img {
          width: 55%;
        }
      }
    }

    .greentex__innovation-dimension {
      width: 100%;
      position: relative;
      text-align: center;

      h1 {
        padding: 50px;
        max-width: 100%;
      }

      .greentex__innovation-dimension-image {
        text-align: center;
        margin: 0 auto;
        width: 100%;

        img {
          width: 65%;
        }
      }
    }

    .greentex__region {
      width: 100%;
      position: relative;
      text-align: center;

      h1 {
        padding: 50px;
        max-width: 100%;
      }

      h4 {
        font-weight: 400;
      }

      img {
        margin: 40px;
      }
    }
  }

  .greentex-footer {
    background-color: $primaryBrusselsColor;
    color: white;
    height: 75px;
    min-height: 75px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    img {
      height: 30%;
    }

    ul {
      display: flex;
      justify-content: space-between;
    }

    .beci-footer-policy-list {
      margin-top: 22px;
      width: 500px;
      align-items: center;

      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);

      a {
        color: white;
        font-size: 18px;

        text-decoration: none;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }

  .greentex__region {
    padding-bottom: 20px;
  }

  @media only screen and (max-width: 1700px) {
    .greentex__button-container {
      width: 60% !important;
    }
  }

  @media only screen and (max-width: 1450px) {
    .greentex_regional_dimension-image-container {
      width: 100% !important;
    }

    .greentex-footer {
      flex-direction: column !important;

      .greentex-logo, .beci-footer-policy-list, .greentex-footer-supporters {
        margin: 0 auto;
      }

      .beci-footer-policy-list {
        line-height: 1;
        margin-top: -20px;
        margin-bottom: 30px;
      }

      .greentex-logo {
        text-align: center;

        img {
          width: 80% !important;
        }
      }

      .greentex-footer-supporters {
        height: 50% !important;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        img {
          height: 100%;
          padding: 5px;
          justify-content: space-between;
        }
      }
    }
  }

  @media only screen and (max-width: 1600px) {
    .objective__text {
      font-size: 18px !important;
    }

    .greentex__logo {
      width: 25%;
    }
  }

  @media only screen and (max-width: 1450px) {
    .greentex__button-container {
      width: 80% !important;
    }
  }

  @media only screen and (max-width: 1440px) {
    .greentex__button-container {
      width: 40% !important;
      flex-direction: column !important;
    }

    .greentex_regional_dimension-map {
      flex-direction: column !important;
      margin: 0 auto !important;
      width: 50% !important;

      .greentex_regional_locations-list {
        margin-top: 24px;
      }

      img {
        width: 100% !important;
        margin: 24px auto !important;
      }
    }
  }

  @media only screen and (max-width: 1409px) {
    .greentex-footer {
      .greentex-footer-supporters {
        padding-bottom: 20px;

        img {
          height: 50px;
          margin-top: 5px;
        }
      }

      .beci-footer-policy-list {
        flex-direction: column !important;
        text-align: center;

        a {
          font-size: 18px !important;
          padding: 10px;
        }
      }
    }
  }

  @media only screen and (max-width: 1070px) {

    .greentex__logo {
      width: 50% !important;
    }

    .greentex__investment-dimension-image {
      img {
        width: 100% !important;
      }
    }

    .greentex__innovation-dimension-image {
      img {
        width: 100% !important;
      }
    }

    .greentex_regional_dimension-map {
      width: 100% !important;

      .greentex_regional_locations-list {
        width: 50% !important;
        margin: 0 auto !important;
        margin-top: 30px !important;
      }

      .greentex_regional_dimension-image {
        img {
          width: 100% !important;
        }
      }
    }


    .beci-footer-policy-list {
      line-height: 0 !important;
      margin-top: 0px !important;
    }

    .greentex__button-container {
      justify-content: space-between;

      a {
        font-size: 18px !important;
        width: 100% !important;
        min-width: fit-content !important;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .beci-footer-policy-list {
      flex-direction: column !important;
      line-height: 1 !important;
      text-align: center !important;
      font-size: 10px !important;
    }

    .greentex-footer-supporters {
      flex-direction: column !important;
      text-align: center !important;

      img {
        width: 80%;
        margin: 0 auto;
      }
    }

    .beci-brussels-supporters__container {
      flex-direction: column !important;
      gap: 1rem;
      text-align: center;

      .powered-by-section {
        order: 2;
      }

      .navigation-links {
        order: 3;
        flex-direction: row !important;
        justify-content: center;
        gap: 1.5rem;
      }

      div:first-child {
        order: 1;
        margin-left: 0 !important;
      }
    }
  }

  @media only screen and (max-width: 757px) {
    .greentex_regional_dimension-map {
      .greentex_regional_locations-list {
        width: fit-content !important;
        margin: 0 auto !important;
        padding-top: 20px;
      }

      img {
        width: 100% !important;
        margin: 0 auto !important;
      }
    }
  }

  @media only screen and (max-width: 700px) {

    .greentex__logo {
      width: 70% !important;
    }

    .greentex__button-container {
      width: 60% !important;
    }
  }

  @media only screen and (max-width: 700px) {
    .brussels__logo-content {
      flex-direction: column !important;
      gap: 1.5rem !important;
    }
  }

  @media only screen and (max-width: 600px) {
    .brussels__logo {
      height: 400px !important;
    }

    .brussels__logo-text {
      font-size: 2rem !important;
      line-height: 1.1 !important;
      max-width: 300px !important;
    }
  }

  @media only screen and (max-width: 450px) {
    .greentex__button-container {
      width: 80% !important;
    }

    .brussels__logo {
      height: 350px !important;
    }

    .brussels__header-logo {
      width: 120px !important;
    }

    .brussels__logo-text {
      font-size: 2rem !important;
      line-height: 1.1 !important;
      max-width: 280px !important;
    }

    .brussels__logo-content {
      gap: 1rem !important;
    }
  }

  @media only screen and (max-width: 375px) {
    .brussels__logo {
      height: 300px !important;
    }

    .brussels__logo-text {
      font-size: 2rem !important;
      line-height: 1.1 !important;
      max-width: 250px !important;
    }
  }
</style>
